import { Box, Checkbox, ScrollArea, Table, Tooltip } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { useDebouncedCallback, useDebouncedState } from "@mantine/hooks";
import { IconRecycle } from "@tabler/icons-react";
import cx from "clsx";
import React, { useCallback, useEffect, useState } from "react";
import { repositoryPos } from "../../../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../../../model/MessageResponse";
import { CustomerGroup } from "../../../../../../model/TblDmCustomer";
import { tblPromotionCommand } from "../../../../../../model/TblPromotion";
import classes from "../../Styles/ScrollTable.module.css";

const CustomersV2 = ({
  form,
  _data,
}: {
  form: UseFormReturnType<
    tblPromotionCommand,
    (values: tblPromotionCommand) => tblPromotionCommand
  >;
  _data: CustomerGroup[];
}) => {
  const [dataTable, setDataTable] = useState<CustomerGroup[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const fetchDataCustomerCat = async () => {
      const dataApi = await repositoryPos.get<MessageResponse<CustomerGroup[]>>(
        "/api/v1/TblDmCustomerGroup/get-all"
      );

      if (dataApi && dataApi.success) {
        const _api = dataApi.data.map((item) => ({
          ...item,
          check: _data?.find((x) => x.id === item.id)?.check,
        }));

        setDataTable((prev) => {
          // Sắp xếp lại danh sách sau khi cập nhật
          const sortedData = [..._api].sort((a, b) => {
            if (a.check && !b.check) return -1;
            if (!a.check && b.check) return 1;
            return 0;
          });

          return sortedData;
        });
      }
    };

    fetchDataCustomerCat();
  }, [_data]);

  const handleSearch = useDebouncedCallback(() => {
    form.setFieldValue(
      "listCustGroup",
      dataTable.filter((item) => item.check && item.check === true)
    );
  }, 500);

  useEffect(() => {
    handleSearch();
  }, [dataTable]);

  useEffect(() => {
    console.log(dataTable);
    const handleResize = () => {
      setHeight(window.innerHeight - 450);
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const handleReset = useCallback((index: number) => {
    setDataTable((prev) => {
      // Cập nhật giá trị orderQuantity và check của phần tử tương ứng
      const updatedData = prev.map((item, i) =>
        i === index ? { ...item, orderQuantity: 0, check: false } : item
      );

      // Sắp xếp lại danh sách sau khi cập nhật
      const sortedData = [...updatedData].sort((a, b) => {
        if (a.check && !b.check) return -1;
        if (!a.check && b.check) return 1;
        return 0;
      });

      return sortedData;
    });
  }, []);

  return (
    <Box mt={10}>
      <ScrollArea h={height}>
        <Table style={{ overflowY: "auto", height: "30px" }}>
          <Table.Thead className={cx(classes.header)}>
            <Table.Tr>
              <Table.Th w={30}>
                <Checkbox readOnly checked={selectAll} />
              </Table.Th>
              <Table.Th>Nhóm khách hàng</Table.Th>
              <Table.Th>Mã</Table.Th>
              <Table.Th>Mô tả</Table.Th>
              <Table.Th w={70}>Thao tác</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody mih={100}>
            {dataTable?.map((branch, index) => (
              <Table.Tr key={index}>
                <Table.Td>
                  <Checkbox readOnly checked={branch.check ?? false} />
                </Table.Td>
                <Table.Td>{branch.name}</Table.Td>
                <Table.Td>{branch.code}</Table.Td>
                <Table.Td>{branch.description}</Table.Td>
                <Table.Td>
                  <Tooltip label="Làm mới">
                    <IconRecycle
                      cursor={"pointer"}
                      color="red"
                      onClick={() => handleReset(index)}
                    />
                  </Tooltip>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
          {dataTable.length < 1 && (
            <Table.Caption>Không có dữ liệu</Table.Caption>
          )}
        </Table>
      </ScrollArea>
    </Box>
  );
};

export default React.memo(CustomersV2);
